import { ButtonProps, useDisclosure } from '@chakra-ui/react';
import { FC } from 'react';
import { useCreateGatewayAccount } from '../../../api/accountsService';
import { MButton } from '../../../components/Monetize';
import useCurrentPaymentGateways from '../../../hooks/useCurrentPaymentGateways';
import { useFlags } from '../../../services/launchDarkly';
import { logger } from '../../../services/logger';
import { GatewayAccountModal } from './GatewayAccountModal';

interface GatewayAccountButtonProps {
  gatewayCustomerId?: string;
  gatewayAccountsDataIsLoading: boolean;
  accountId: string;
  buttonProps?: Pick<ButtonProps, 'size' | 'variant' | 'mt'>;
}

export const GatewayAccountButton: FC<GatewayAccountButtonProps> = ({
  gatewayCustomerId,
  gatewayAccountsDataIsLoading,
  accountId,
  buttonProps = { size: 'sm', variant: 'tertiary' },
}) => {
  const { enableGatewayAccountModal } = useFlags();

  const { open: isOpen, onOpen, onClose } = useDisclosure();

  const { currentPaymentGateway } = useCurrentPaymentGateways({
    meta: { showErrorToast: true },
  });

  const { mutateAsync: doCreatePaymentGatewayAccount, isPending } =
    useCreateGatewayAccount({
      onSuccess: (data) => {
        logger.info('Gateway account created successfully:', data);
        onOpen();
      },
      onError: (error) => {
        logger.error('Failed to create gateway account:', error);
      },
    });

  if (!enableGatewayAccountModal || !currentPaymentGateway) {
    return null;
  }

  if (gatewayCustomerId) {
    return (
      <GatewayAccountModal
        accountId={accountId}
        key={currentPaymentGateway.id}
        isLoading={gatewayAccountsDataIsLoading}
        paymentGatewayId={currentPaymentGateway.id}
        gatewayCustomerId={gatewayCustomerId}
        buttonProps={buttonProps}
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
    );
  }

  return (
    <MButton
      {...buttonProps}
      isLoading={isPending || gatewayAccountsDataIsLoading}
      onClick={() => {
        doCreatePaymentGatewayAccount({
          accountId,
          paymentGatewayId: currentPaymentGateway.id,
        });
      }}
    >
      Create Payment Gateway Account
    </MButton>
  );
};
